import { render } from "./commodityMain.vue?vue&type=template&id=2a06d5e0&scoped=true"
import script from "./commodityMain.vue?vue&type=script&lang=js"
export * from "./commodityMain.vue?vue&type=script&lang=js"

import "./commodityMain.vue?vue&type=style&index=0&id=2a06d5e0&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a06d5e0"]])

export default __exports__